<template>
    <v-card v-if="user.id !== draft.user_id">
        <v-card-title>
            <h4 class="text-dark">
                Voulez-vous prendre la main sur le brouillon en cours de <br>
                {{ draft.user_first_name }} {{ draft.user_name }} ?
            </h4>
        </v-card-title>
        <v-card-text>
            Brouillon créé le {{ formatDate(draft.drafted_at) }}
        </v-card-text>
        <v-card-actions class="w-100 px-6 d-flex justify-content-end">
            <v-btn color="error" @click="closeModal()">
                ANNULER
            </v-btn>

            <v-btn color="primary" @click="takeThePowerBack">
                <v-icon left>edit_note</v-icon>
                PRENDRE LA MAIN
            </v-btn>
        </v-card-actions>
    </v-card>

    <v-card v-else>
        <v-card-title>
            <h4 class="text-dark">
                Vous avez un brouillon en cours sur cette fiche.
            </h4>
        </v-card-title>
        <v-card-text>
            Brouillon créé le {{ formatDate(draft.drafted_at) }}
        </v-card-text>
        <v-card-actions class="w-100 px-6 d-flex justify-content-end">
            <v-btn color="error" @click="closeModal">
                ANNULER
            </v-btn>

            <v-btn color="primary" @click="continueDraft">
                <v-icon left>edit_note</v-icon>
                ACCEDER AU BROUILLON
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
import { mapState, mapMutations } from "vuex"

export default {
    name: "TakePowerBackModal",
    props: ["draft"],
    data() {
        return {}
    },
    methods: {
        ...mapMutations("web_form", ["setReadOnly"]),
        takeThePowerBack() {
            let payload = {
                webFormId: this.draft.web_form_id,
                userId: this.user.id,
            }

            this.$global.loading = true

            this.$http.post("sitform/take-draft-control", payload).then(res => {
                if (res.body.success) {
                    this.continueDraft()
                } else {
                    this.$global.loading = false
                }

                this.closeModal()
            })
        },
        continueDraft() {
            if(this.$route.path.includes('sit/formulaire')) {
                this.closeModal()
                this.setReadOnly(false)
                this.reloadProvider(this.draft.provider_data_id, this.draft.aspect)
            } else {
                this.$router.push({
                    path: "/sit/formulaire/" + this.draft.provider_id,
                    query: {
                        providerDataId: this.draft.provider_data_id,
                        newDraft: false,
                        aspect: this.draft.aspect
                    },
                })
            }
        },
        closeModal() {
            this.$global.$emit('close_take_power_back_modal')
        },
        reloadProvider(providerDataId) {
            this.$global.$emit("get-provider", providerDataId)
            this.$global.loading = true

            setTimeout(() => {
                this.$global.$emit("init-opening-periods")
                this.$global.$emit("init-price-periods")
                this.$global.$emit("init-contacts")
            }, 3000)
            this.$global.loading = false
        },
    },
    computed: {
        ...mapState("account", ["account", "user"]),
    },
}
</script>